import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import apiService from '../../services/api.service'
import _ from 'lodash'
import { messageActions } from '../../store/message'

const BASE_PATH = '/lottustech/orcamento'
const crud = build(validate, BASE_PATH)
const prefix = 'crudOrcamento'

const newTypes = {
  RESET: `${prefix}reset`,
}
const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.contratar = () => {
  return (dispatch, getState) => {
    const state = getState()[`crudOrcamentoState`]
    apiService
      .post(`${BASE_PATH}/contratar/${state.currentRecord.oid}`)
      .then((response) => {
        const status = _.get(response, 'data.statusOrcamento', null)
        const oidContrato = _.get(response, 'data.oidContrato', null)
        if (status) {
          dispatch(actions.setField('status', status))
          dispatch(actions.setField('oidContrato', oidContrato))
        }
        if (oidContrato) {
          const msg = {
            sticky: false,
            summary: '',
            severity: 'success',
            detail: `Foi criado o contrato #${oidContrato}`,
          }
          dispatch(messageActions.messageShowMessages([msg]))
        }
      })
      .catch((error) => {
        const msg = _.get(error, 'response.data', '')
        dispatch(messageActions.messageShowMessages(makeMessages([msg], 'error')))
      })
  }
}

actions.cancelar = () => {
  return (dispatch, getState) => {
    const state = getState()[`crudOrcamentoState`]
    apiService
      .post(`${BASE_PATH}/cancelar/${state.currentRecord.oid}`)
      .then((response) => {
        const msg = {
          sticky: false,
          summary: '',
          severity: 'success',
          detail: `Orçamento cancelado com sucesso.`,
        }
        dispatch(messageActions.messageShowMessages([msg]))
        dispatch(actions.loadById(state.currentRecord.oid))
      })
      .catch((error) => {
        const msg = _.get(error, 'response.data', '')
        dispatch(messageActions.messageShowMessages(makeMessages([msg], 'error')))
      })
  }
}

actions.imprimir = (oid) => {
  return (dispatch, getState) => {
    const path = BASE_PATH + `/report/${oid}`
    return apiService.post(path).then((response) => {
      const win = window.open(response.data)
      if (win) {
        win.focus()
      }
    })
  }
}

actions.showWarningMessage = (message) => {
  return (dispatch, getState) => {
    dispatch(messageActions.messageShowMessages(makeMessages([message], 'warn')))
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = ''
  if (type === 'error') {
    summary = ''
    sticky = true
  } else if (type === 'warn') {
    summary = ''
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
